module.exports = __webpack_public_path__ + "img/vip.0d7a565d.jpg";